export const getTaxRuleList = () => {
	return {
		method: "GET",
		url: `${process.env.REACT_APP_ORIGIN}/tax_rule/`,
	}
}
